import { Icon } from '@iconify/react';
import type { PlayerNotification } from '@/services/notificationService';
import { getNotificationActionIcon, getNotificationIcon } from '@/utils/notificationIcon';
import { formatRelativeNotificationTime } from '@/utils/notificationTime';

interface NotificationCardProps {
  item: PlayerNotification;
  onOpen: (item: PlayerNotification) => void;
}

export function NotificationCard({ item, onOpen }: NotificationCardProps) {
  const icon = getNotificationIcon(item.type);
  const unread = item.readAt == null;

  return (
    <article className="bg-white rounded-2xl border border-[#E0E6ED] px-4 py-3.5">
      <button type="button" onClick={() => onOpen(item)} className="w-full text-left cursor-pointer">
        <div className="flex items-start gap-3">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${icon.wrapClass}`}>
            <Icon icon={icon.icon} className={`w-5 h-5 ${icon.iconClass}`} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-start justify-between gap-3">
              <h3 className="text-sm font-bold text-[#0E1726] leading-snug">{item.title}</h3>
              <div className="flex items-center gap-1.5 shrink-0 pt-0.5">
                <span className="text-xs text-gray-400">
                  {formatRelativeNotificationTime(item.createdAt)}
                </span>
                {unread ? <span className="w-1.5 h-1.5 rounded-full bg-[#FC480D]" /> : null}
              </div>
            </div>
            <p className="text-sm text-[#0E1726]/70 leading-relaxed mt-1">{item.body}</p>
          </div>
        </div>
      </button>
      {item.actionLabel ? (
        <div className="pl-[52px] mt-3">
          <button
            type="button"
            onClick={() => onOpen(item)}
            className="inline-flex items-center gap-1.5 bg-[#FC480D] text-white text-xs font-semibold px-3 py-1.5 rounded-full cursor-pointer"
          >
            <Icon icon={getNotificationActionIcon(item.actionLabel)} className="w-3.5 h-3.5" />
            {item.actionLabel}
          </button>
        </div>
      ) : null}
    </article>
  );
}
